<template>
  <ConfirmationModal
    :bodyText="bodyText"
    :cancelText="numEligibleUsers ? 'cancel' : ''"
    :continueText="numEligibleUsers ? 'unlock' : 'ok'"
    :handleCancel="hideModal"
    :handleContinue="action"
    headerText="Unlock User Account"
  />
</template>

<script>
import { mapGetters } from 'vuex';
import ConfirmationModal from 'components/Modal/ModalComponents/ConfirmationModal.vue';
import ModalEventBus from 'components/Modal/ModalEventBus';

export default {
  name: 'UnlockUserModal',

  components: {
    ConfirmationModal,
  },

  props: {
    action: {
      type: Function,
      default: () => {},
    },

    item: {
      type: Object,
      default: undefined,
    },
  },

  computed: {
    ...mapGetters('SystemUserCollection', {
      ineligibleUsers: 'getUsersIneligibleForUnlock',
      selectedItems: 'getSelectedItems',
    }),

    bodyText() {
      const preface = 'Accounts are locked due to repeated failed login attempts.';
      const prefaceSingle = 'This account is locked due to repeated failed login attempts.';
      const mainText = 'Unlocking will clear accumulated failed login attempts and let the user regain access using their existing credentials.';

      // Unlocking a single user from the aside panel
      if (this.item) {
        return `${prefaceSingle} ${mainText} Are you sure you'd like to unlock this user?`;
      }

      // No selected users are eligible
      if (this.numEligibleUsers === 0) {
        return 'None of the selected users have locked accounts.';
      }

      // All selected users are eligible
      if (this.numEligibleUsers === this.selectedItems.length) {
        return `${preface} ${mainText}`;
      }

      // Some selected users are eligible
      return `${this.numEligibleUsers} of ${this.selectedItems.length} selected users have locked accounts. ${preface} ${mainText}`;
    },

    numEligibleUsers() {
      if (this.item) {
        return 1;
      }
      return this.selectedItems.length - this.ineligibleUsers.length;
    },
  },

  methods: {
    hideModal() {
      ModalEventBus.close();
    },
  },
};
</script>
